import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { OptimizationRunState } from '../slices/optimizationProgressSlice';
import { getActiveComponentDesignGuid } from './getActiveComponentDesignSelector';

/** The most recent optimization run, but only while the component it belongs to is the one being looked at. */
export const getOptimizationRunForActiveComponent = createSelector(
  (state: RootState) => state.optimizationProgress.latestRun,
  getActiveComponentDesignGuid,
  (latestRun, activeComponentDesignGuid): OptimizationRunState | null =>
    latestRun != null && latestRun.componentDesignGuid === activeComponentDesignGuid ? latestRun : null,
);

export const isOptimizationRunningForActiveComponent = createSelector(
  getOptimizationRunForActiveComponent,
  (run) => run != null && run.status !== 'completed' && run.status !== 'failed',
);
